import { get, post } from '../utils/axios/https';

const volumeServices = {
    getVolumeContracts: () => get(`api/volumen/contratoproducto/`),
    validateProduct: (body) => post(`api/consumo/validar/`, body),
    registerProductByVolume: (body) => post(`api/volumen/consumo/registrar/`, body),
};

export default volumeServices;
